import React from "react";
import { Helmet } from "react-helmet";
import StaticPageStyle from "./StaticPageStyle";

const CONTACT_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScr_mdaYyQTyupt-RKCRfKZcaXA3G4qPvjc2WcU0ZsO-nTb5w/viewform";

const ContactUs = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Contact Us — Propeller PH</title>
        <meta
          name="description"
          content="Get in touch with Propeller PH — email, phone, or send an inquiry about buying, leasing, or listing a property in the Philippines."
        />
        <link rel="canonical" href="https://www.propeller.ph/contact-us" />
      </Helmet>
      <StaticPageStyle>
        <div className="container">
          <h1>Contact Us</h1>
          <p className="page-meta">
            We usually respond within one business day.
          </p>

          <p>
            Whether you're looking to buy, lease, or list a property — or just
            have a question about a listing you saw on the Site — we'd love to
            hear from you.
          </p>

          <div className="contact-cards">
            <div className="contact-card">
              <h2>Email</h2>
              <p>
                <a href="mailto:propeller.realty@gmail.com">
                  propeller.realty@gmail.com
                </a>
              </p>
            </div>
            <div className="contact-card">
              <h2>Phone</h2>
              <p>
                <a href="tel:+639060012922">+63 906 001 2922</a>
              </p>
            </div>
            <div className="contact-card">
              <h2>Office</h2>
              <p>West Capitol Drive, Kapitolyo, Pasig</p>
              <p>Metro Manila, Philippines</p>
            </div>
            <div className="contact-card">
              <h2>Social</h2>
              <p>
                <a
                  href="https://www.facebook.com/Propeller.Realty/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
                {" · "}
                <a
                  href="https://instagram.com/propeller.realty"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
                {" · "}
                <a
                  href="https://www.youtube.com/@PropellerRealty"
                  target="_blank"
                  rel="noreferrer"
                >
                  YouTube
                </a>
              </p>
            </div>
          </div>

          <h2>Send us an inquiry</h2>
          <p>
            The fastest way to reach the right person is our inquiry form.
            Tell us what you're looking for and how to reach you, and we'll
            get back to you.
          </p>
          <a
            className="btn-primary"
            href={CONTACT_FORM_URL}
            target="_blank"
            rel="noreferrer"
          >
            Open inquiry form
          </a>

          <p>
            Asking about a specific property? Every listing page also has its
            own inquiry form that sends your question straight to the agent
            handling that property.
          </p>
        </div>
      </StaticPageStyle>
    </React.Fragment>
  );
};

export default ContactUs;
